import * as tizra from 'tizra'
import * as R from 'rambdax'

const log = tizra.logger('quickstart/lib/search/hooks')

/**
 * Run a config-defined hook with payload augmented by standard utilities.
 */
export function runHook(hook, payload = {}) {
  return hook({
    ...payload,
    utils: {
      ...tizra,
      log, // should be overridden by caller
      ...payload.utils,
    },
  })
}

/**
 * Run a named hook across all the fields that define it, merging results
 * as they are returned.
 */
export function runFieldsHook(hookName, fields, payload) {
  return R.compose(
    R.reduce((payload, field) => {
      const logName = `${hookName}/${field.name}`
      log.debug?.(`running ${logName}`)
      const ret = runHook(field.hooks[hookName], {
        field,
        ...payload,
        utils: {
          ...payload.utils,
          log: tizra.logger(`hooks/${logName}`),
        },
      })
      log.debug?.(`done ${logName}`, ret)
      return {...payload, ...ret}
    }, payload),
    R.filter(R.path(['hooks', hookName])),
    R.values,
  )(fields)
}
